<div class="description">
  <div class="description__text">See where</div>
  <div class="description__text">the world</div>
  <div class="description__text description__text--dimmed">
    <span *ngIf="titles" [coaTextAnimation]="titles" class="description__label"></span>
    <span class="description__caret"></span>
  </div>
  <div class="description__text">is going</div>
</div>

